import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-h5 text-center" }

import { useDialogsStore } from '@/store/dialogs';
import { useUserStore } from '@/store/user';
import { ref, watch } from 'vue';
import UserCompaniesSelector from '@/components/shared/UserCompaniesSelector';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeCompanyDialog',
  emits: ['companySelected'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const dialogsStore = useDialogsStore();
const userStore = useUserStore();

const selectedCompany = ref(userStore.currentCompany);
const companyName = ref('');

watch(
    () => dialogsStore.changeCompany,
    () => {
        if (dialogsStore.changeCompany === true) {
            selectedCompany.value = userStore.currentCompany;
        }
    }
);

function closeDialog() {
    selectedCompany.value = null;
    companyName.value = '';
    dialogsStore.changeCompany = false;
}

function saveChooseCompany() {
    emit('companySelected', selectedCompany.value.companyId);
    closeDialog();
}

function chooseCompany(company) {
    selectedCompany.value = company;
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    class: "font",
    modelValue: _unref(dialogsStore).changeCompany,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dialogsStore).changeCompany) = $event)),
    "onClick:outside": closeDialog
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, {
        width: "400",
        class: "pb-6 pt-1 px-1 rounded-xl"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            justify: "end",
            "align-items": "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                onClick: closeDialog,
                style: {"float":"right","right":"0px"},
                fab: "",
                absolute: "",
                icon: "",
                color: "white",
                variant: "text",
                class: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { color: "secondary" }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-close")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            "no-gutters": "",
            justify: "center",
            "align-items": "center",
            class: "px-6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "px-2" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('choose_company')), 1),
                    _createVNode(_unref(UserCompaniesSelector), {
                      onSelect: chooseCompany,
                      value: selectedCompany.value,
                      class: "mt-6"
                    }, null, 8, ["value"]),
                    _createVNode(_component_v_btn, {
                      rounded: "pill",
                      class: "text-uppercase mt-6",
                      color: "primary",
                      flat: "",
                      block: "",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (saveChooseCompany()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('save')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})